// extracted by mini-css-extract-plugin
module.exports = {"backAndNextRow":"styles_backAndNextRow__3Ydxv"};